import _ from 'lodash';

import { ftpSelectComponent } from 'app/shared/components/select/select.component';
import { ftpDropdownComponent } from './dropdown/dropdown.component';

export const addSharedComponents = (angularModule) => {
    _.forEach([ftpSelectComponent, ftpDropdownComponent], (component) => {
        angularModule.component(component.name, component);
    });
};
